/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Button from "components/common_components/Button";
import Page from "components/common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Header from "components/common_components/Header";
import FormsContext from "./FormsContext";
import Status from "components/common_components/Status";
import { useHistory } from "react-router-dom";
import { Grid, MenuItem, TextField } from "@material-ui/core";
import forms from "utils/static/forms";
import Icon from "components/common_components/Icon";

const headCells = [
    { index: 1, id: "client.fullName", label: "Client", sortable: false },
    { index: 2, id: "form.code", label: "Form" },
    { index: 3, id: "form.category", label: "Category" },
    { index: 4, id: "form.issuer", label: "Issuer" },
    {
        index: 5,
        id: "status",
        label: "Status",
        render: (_, { value, data }) => {
            return <Status id={value} withIcon />;
        },
    },
    {
        index: 6,
        id: "stampCreationDatetimeString",
        orderBy: "stampCreationDatetime",
        label: "Created",
    },
    {
        index: 7,
        id: "stampModificationDatetimeString",
        orderBy: "stampModificationDatetime",
        label: "Modified",
    },
];

function List() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);

    const [issuer, setIssuer] = useState("");
    const [category, setCategory] = useState("");
    const [status, setStatus] = useState(null);

    const [quickFilterValueTemp, setQuickFilterValueTemp] = useState("");
    let timeOut = null;
    const [quickFilterValue, setQuickFilterValue] = useState("");

    const onIssuerChange = (e) => {
        setIssuer(e.target.value);
    };

    const onCategoryChange = (e) => {
        setCategory(e.target.value);
    };

    const onStatusChange = (e) => {
        setStatus(e.target.value);
    };

    const onQuickFilterChange = (e) => {
        if (timeOut) {
            clearTimeout(timeOut);
        }
        console.log("e.target.value", e.target.value);

        setQuickFilterValueTemp(e.target.value);
        timeOut = setTimeout(() => {
            setQuickFilterValue(e.target.value);
        }, 1200);
    };

    const onClearFilters = () => {
        setIssuer("");
        setCategory("");
        setStatus(null);
        setQuickFilterValue("");
        setQuickFilterValueTemp("");
    };

    const { FormClients } = useContext(FormsContext);

    function getFormClients(requestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        FormClients.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getFormClients();

        return () => {
            setData([]);
        };
    }, []);

    useEffect(() => {
        onFilterChange();
    }, [issuer, category, status, quickFilterValue]);

    function onRowClickHandler(item) {
        history.push(`/forms/${item.id}`);
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getFormClients();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        FormClients.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    const buildCustomFilter = () => {
        const customFilters = {};
        if (quickFilterValue) {
            customFilters.quickFilterValue = quickFilterValue;
        }
        if (issuer || category) {
            customFilters.form = {};
            if (issuer) {
                customFilters.form.issuer = issuer;
            }
            if (category) {
                customFilters.form.category = category;
            }
        }
        if (status) {
            customFilters.status = status.value;
        }
        return customFilters;
    };

    const onFilterChange = () => {
        getFormClients({
            filter: buildCustomFilter(),
            orderBy: "stampModificationDatetime",
            orderDirection: "desc",
            pageNumber: 0,
            pageSize: 10,
        });
    };

    return (
        <Page className="forms-list-page">
            <Header title="Forms">
                <Button primary onClick={() => history.push("/forms/add/wizard")}>
                    <Icon name="add" size="md" color="white" />
                    <span>Create new</span>
                </Button>
            </Header>
            <div className="layout custom-filters">
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={6} md={2}>
                        <TextField
                            select
                            value={issuer}
                            onChange={onIssuerChange}
                            label="Issuer"
                            fullWidth
                            variant="standard"
                            size="small"
                            margin="dense"
                        >
                            <MenuItem key={-1} value={null}>
                                Select...
                            </MenuItem>
                            {forms.issuers.map((i, index) => (
                                <MenuItem key={index} value={i}>
                                    {i}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            select
                            value={category}
                            onChange={onCategoryChange}
                            label="Category"
                            fullWidth
                            variant="standard"
                            size="small"
                        >
                            <MenuItem key={-1} value={null}>
                                Select...
                            </MenuItem>
                            {forms.categories.map((c, index) => (
                                <MenuItem key={index} value={c}>
                                    {c}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <TextField select value={status} onChange={onStatusChange} label="Status" multiline fullWidth size="small">
                            <MenuItem key={-1} value={null}>
                                Select...
                            </MenuItem>
                            {forms.statuses.map((s, index) => (
                                <MenuItem key={index} value={s}>
                                    <Status id={s.value} withIcon />
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} />
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            value={quickFilterValueTemp}
                            onChange={onQuickFilterChange}
                            label="Type to search"
                            placeholder="Jot something down..."
                            fullWidth
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} />
                    <Grid item xs={12} sm={6} md={2}>
                        <Button link secondary onClick={onClearFilters}>
                            Clear filters
                        </Button>
                    </Grid>
                </Grid>
            </div>
            <div className="layout forms-table">
                {isLoading && <LoadingPage />}
                {!isLoading && (
                    <EnhancedTable
                        headCells={headCells}
                        data={data}
                        defaultOrder={{ order: "desc", orderBy: "stampModificationDatetimeString" }}
                        keyColumnName="id"
                        onRowClick={onRowClickHandler}
                        onDelete={onDeleteHandler}
                        onRequestData={getFormClients}
                        filterBuilder={buildCustomFilter}
                        pageableData={pageableData}
                        defaultRowsPerPage={10}
                        filterable={false}
                        deletable
                        selectable
                    />
                )}
            </div>
        </Page>
    );
}

export default List;
